import type { PromoCampaignErrorRow } from '../model/types'

import { entries, size } from 'lodash/fp'

export const getCountPromoCampaignErrors = (
	errors: Record<string, PromoCampaignErrorRow[]>
): [string, number][] => entries(errors).map(([key, val]) => [key, size(val)])
